import CrisisInformationBar from './CrisisInformationBar';

export default CrisisInformationBar;
